(function () {
  "use strict";

  function setupSliderule(buttonSelector, panelSelector) {
    document.addEventListener("click", function (event) {
      const button = event.target.closest(buttonSelector);
      if (button) {
        const wrapper = button.closest(".sliderule__wrapper");
        if (wrapper) {
          const panel = wrapper.querySelector(panelSelector);
          if (panel) {
            panel.classList.toggle("convx__close");
            button.classList.toggle("convx__close");
          }
        }
      }
    });
  }

  function onDOMContentLoaded() {
    setupSliderule("[data-convx-nav-btn]", "[data-convx-nav-panel]");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
